import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_INSPECTIONS } from './vehicleEntityConfigs';

const VehicleInspections = () => <VehicleEntityGridPage config={VEHICLE_INSPECTIONS} />;

export default VehicleInspections;
